<template>
    <footer class="FooterBlock" :id=block_id>

        <!-- Main Footer -->
        <div class="bg-neutral-50">
            <div class="container-block">
                <div class="flex flex-col justify-between gap-12 py-8 md:py-0 xl:gap-x-16 md:flex-row">
                    
                    <!-- Info -->
                    <div class="flex flex-col items-start">
                        
                        <!-- Logo -->
                        <a href="/" class="flex-shrink-0">
                            <img class="w-auto h-8 md:h-10" src="@/assets/icons/logo-lw/light.svg" alt="Logo">
                        </a>

                        <!-- Copy -->
                        <div class="mt-4 body-md text-neutral-600 max-w-[25ch] ">
                            <p>Taste the best of our cuisine, from Argentina, to Mexico, to Venezuela and beyond.</p>
                        </div>

                        <!-- Contact -->
                        <div class="flex flex-col items-start gap-2 mt-6 lg:mt-8">

                            <cta-phone />

                            <cta-email />
                            
                        </div>

                        <div class="mt-4 lg:mt-6">
                            <cta-socials />
                        </div>
                        
                    </div>

                    <!-- Nav -->
                    <div class="flex flex-col justify-center gap-12 lg:gap-16 md:flex-row lg:justify-end xl:gap-24 ">
                        
                        <!-- Address -->
                        <div class="flex flex-col items-start gap-3">

                            <p class="text-neutral-800 head-xs">Address</p>

                            <address class="not-italic body-md text-neutral-600 ">
                                <p>8, Belmont Street</p>
                                <p>Aberdeen City</p>
                                <p>AB10 1JE</p>
                            </address>
                            
                        </div>

                        <!-- Order -->
                        <div class="flex-col items-start hidden gap-3 lg:flex">

                            <p class="text-neutral-800 head-xs">How to Order</p>

                            <ul class="flex flex-col items-start gap-2">
                                <li><a href="https://goodeats.io/LATINWAY/" class="transition body-md text-neutral-600 hover:text-neutral-800 active:text-neutral-500">Collection</a></li>
                                <li><a href="https://goodeats.io/LATINWAY/" class="transition body-md text-neutral-600 hover:text-neutral-800 active:text-neutral-500">Delivery</a></li>
                                <li><a href="https://goodeats.io/LATINWAY/" class="transition body-md text-neutral-600 hover:text-neutral-800 active:text-neutral-500">Catering</a></li>
                                <li><a href="../../files/menu.pdf" class="btn btn-md btn-link btn-secondary">View Menu →</a></li>
                            </ul>

                        </div>

                        <!-- Sitemap -->
                        <nav class="flex flex-col items-start gap-3">

                            <p class="text-neutral-800 head-xs">Latinway</p>

                            <ul class="flex flex-col items-start gap-2">
                                <li><a href="#Timetable" class="transition body-md text-neutral-600 hover:text-neutral-800 active:text-neutral-500">Timetable</a></li>
                                <li><a href="#Order" class="transition body-md text-neutral-600 hover:text-neutral-800 active:text-neutral-500">How to Order</a></li>
                                <li><a href="#About" class="transition body-md text-neutral-600 hover:text-neutral-800 active:text-neutral-500">About Us</a></li>
                                <li><a href="#Contact" class="transition body-md text-neutral-600 hover:text-neutral-800 active:text-neutral-500">Contact Us</a></li>
                                <li><a href="https://goodeats.io/LATINWAY/" class="btn btn-md btn-link btn-primary">Order Now →</a></li>
                            </ul>

                        </nav>

                    </div>

                </div>
            </div>
        </div>

        <!-- Credits Area -->
        <div class="bg-neutral-800">
            <div class="max-w-md px-6 py-6 mx-auto md:max-w-screen-md lg:max-w-screen-xl xl:max-w-screen-2xl md:py-8 lg:py-10 xl:py-8 md:px-8 lg:px-16 xl:px-32">
                <div class="flex flex-col justify-between gap-4 md:items-baseline lg:gap-6 md:flex-row">
                    
                    <p class="body-md text-neutral-300">
                        Latinway © <span>{{ new Date().getFullYear() }}</span>
                    </p>

                    <p class="body-md text-neutral-300">
                        Made with <span>♥️&#xFE0F;</span> by <a class="font-bold transition hover:text-white" href="https://sergiocastillo.dev/">Sergio Castillo</a> 
                    </p>

                </div>
            </div>
        </div>
        
    </footer>
</template>

<script>

    import CtaPhone from '../components/cta/CtaPhone';
    import CtaEmail from '../components/cta/CtaEmail';
    import CtaSocials from '../components/cta/CtaSocials';

    export default {

        name: 'FooterBlock',

        components: {
            CtaPhone,
            CtaEmail,
            CtaSocials
        },

        data(){
            return {
                block_id: "Footer",
            }
        }
    }
    
</script>
